import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileCallCta from '../components/MobileCallCta';
import styled from 'styled-components';

const MainContent = styled.main`
  min-height: calc(100vh - 200px); /* Adjust based on header and footer height */
`;

/* Spacer prevents the fixed mobile CTA bar from overlapping footer content */
const MobileCtaSpacer = styled.div`
  height: 56px;

  @media (min-width: 769px) {
    display: none;
  }
`;

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <>
      <Header />
      <MainContent>{children}</MainContent>
      <Footer />
      <MobileCtaSpacer />
      <MobileCallCta />
    </>
  );
};

export default MainLayout;
